import React, { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';

export default function SmartModal({ show, onHide, onCancel, onClose, children, ...rest }) {
  const contentRef = useRef(null);

  const modalRefs = [];

  function registerModal(entry) {
    modalRefs.push(entry);
  }

  function unregisterModal(ref) {
    const index = modalRefs.findIndex((entry) => entry.ref === ref);
    if (index !== -1) {
      modalRefs.splice(index, 1);
    }
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== 'Escape') return;
      if (modalRefs.length === 0) return;

      const lastModal = modalRefs[modalRefs.length - 1];
      if (!lastModal) return;

      const { onHide } = lastModal;

      if (onHide) onHide();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (show) registerModal({ ref: contentRef, onHide: onHide ?? onClose ?? onCancel });
    else unregisterModal(contentRef);

    return () => unregisterModal(contentRef);
  }, [show, onHide, onClose, onCancel]);

  return (
    <Modal show={show} keyboard={false} onHide={onHide || onClose || onCancel} {...rest}>
      {children}
    </Modal>
  );
}
